module.exports = __webpack_public_path__ + "img/allTeam.afddcbe6.png";